const TAB_KEY = 'additionalInfo'
export default {
  name: 'additionalInformation',

  computed: {
    additionalInformationEditConfig () {
      return {
        title: this.$t('administration/partner.additional_info'),
        key: TAB_KEY,
        formData: this.formData,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'partnerLocations', edit)
        },
        tabContent: [
          {
            component: this.columnsContentComponent,
            // styles for making component to fill remaining space
            mainDivStyle: {
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1
            },
            cardStyle: {
              flexGrow: 1
            },
            title: this.$t('administration/partner.additional_info_details'),
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'additional_info',
                    type: 'textarea',
                    label: this.$t('administration/partner.additional_info'),
                    placeholder: this.$t('administration/partner.enter_additional_info'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
